export function stripCountryCode(phoneNumber = '', countryCode = '+1') {
  if (!phoneNumber) {
    return '';
  }

  const normalizedCode = countryCode.replace(/[^0-9+]/g, '');
  const codeWithoutPlus = normalizedCode.replace('+', '');

  if (phoneNumber.startsWith(countryCode) || phoneNumber.startsWith(normalizedCode)) {
    return phoneNumber.slice(countryCode.length);
  }

  if (phoneNumber.startsWith(codeWithoutPlus)) {
    return phoneNumber.slice(codeWithoutPlus.length);
  }

  return phoneNumber;
}
